// MenuListSection.tsx
import Image from "next/image";
import { MenuCard } from "../organisms/MenuCard";

type Menu = {
  id: number;
  image: string;
  icon?: string;
  title: string;
  subtitle?: string;
  description: string;
  ctaLabel: string;
  ctaLink?: string;
  style?: string;
  price?: {
    main: string; // "à partir de 12,80€ TTC"
    sub?: string; // "(11,64€ HT)"
    extra?: string; // "9,64€ après aides fiscales"
  };
};

export default function MenuListSection({ menus }: { menus: Menu[] }) {
  return (
    <section className="relative isolate overflow-visible pt-5">
      <Image
        src={`https://site-lms.fra1.digitaloceanspaces.com/Gauche_35ce480274.png`}
        alt="Illustration de légumes"
        width={243}
        height={1014}
        className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 -z-10 h-full w-auto opacity-90"
      />
      <Image
        src={`https://site-lms.fra1.digitaloceanspaces.com/droit_c75229068c.png`}
        alt="Illustration de légumes"
        width={243}
        height={1014}
        className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 -z-10 h-full w-auto opacity-90"
      />
      {/* <img
        aria-hidden
        src="/images/Gauche.png"
        className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 -z-10 h-full w-auto opacity-90"
      />
      <img
        aria-hidden
        src="/images/droit.png"
        className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 -z-10 h-full w-auto opacity-90"
      /> */}

      {/* Contenu centré */}
      <div className="relative z-10 mx-auto max-w-[1000px] px-0">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full  ">
          {menus.map((m) => (
            <MenuCard
              key={m.id}
              image={m.image}
              icon={m.icon}
              title={m.title}
              subtitle={m.subtitle}
              description={m.description}
              ctaLabel={m.ctaLabel}
              ctaLink={m.ctaLink}
              price={m.price}
              style={m.style || ""}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
